// src/pages/TradingData/compositeConstants.js
// Shared constants for the Composite Generator feature.

export const API_BASE = process.env.REACT_APP_API_URL || '';
export const EXPLORE_URL = `${API_BASE}/strategies/api/signals/explore-trades/`;
export const SIGNAL_TYPES_URL = `${API_BASE}/strategies/api/signal-types/`;
export const ANALYZE_INLINE_URL = `${API_BASE}/strategies/api/analyze/inline/`;

export const ACCENT = '#a78bfa';
export const WIN_COLOR = '#00ff88';
export const LOSS_COLOR = '#ef4444';
export const COMPANION_COLOR = '#00d4ff';
export const FILTER_COLOR = '#f59e0b';

export const DAY_LABELS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
export const SESSION_HOURS = { ETH: [0, 9], RTH: [9, 16] };

export const CATEGORY_COLORS = {
  companion: COMPANION_COLOR,
  temporal: '#f59e0b',
  compound: ACCENT,
  indicator: '#a855f7',
};

export const STEPS = ['Configure', 'Raw Results', 'Feature Analysis', 'Composite Config', 'Performance'];
